import OidcCallback from './oidc-callback-page.vue';
import OidcSilentRenew from './oidc-silent-renew-page.vue';
import OidcCallbackError from './oidc-callback-error-page.vue';
import NotFound from './not-found-page.vue';
import AccessDenied from './access-denied-page.vue';

export default [
	{
		path: '/system/oidc-callback', // Needs to match redirectUri (redirect_uri if you use snake case) in your oidcSettings
		name: 'oidc-callback',
		component: OidcCallback,
		meta: {
			isPublic: true,
			notCompanyRoute: true
		}
	},
	{
		path: '/system/oidc-silent-renew', // Needs to match redirectUri (redirect_uri if you use snake case) in your oidcSettings
		name: 'oidc-silent-renew',
		component: OidcSilentRenew,
		meta: {
			isPublic: true,
			notCompanyRoute: true
		}
	},
	{
		path: '/system/oidc-callback-error', // Needs to match redirectUri (redirect_uri if you use snake case) in your oidcSettings
		name: 'oidc-callback-error',
		component: OidcCallbackError,
		meta: {
			isPublic: true,
			notCompanyRoute: true
		}
	},
	{
		path: '/system/access-denied',
		name: 'access-denied',
		component: AccessDenied,
		meta: {
			isPublic: true,
			notCompanyRoute: true
		},
		props: route => ({
			title: route.query.title,
			subtitle: route.query.subtitle,
			btnText: route.query.btnText,
			btnRoute: route.query.btnRoute,
			fromIframe: route.query.fromIframe,
			fromUrl: route.query.fromUrl
		})
	},
	{
		path: '*',
		name: 'not-found',
		component: NotFound,
		meta: {
			isPublic: true,
			notCompanyRoute: true
		}
	}
];
